<template>
  <div class="mb-32">
    <h1 class="my-10 text-xl lg:text-3xl tracking-wide uppercase text-left">
      {{$t('messages.message')}}
    </h1>
    <div class="flex mb-20 justify-between">
      <div class="flex">
        <button
          @click="currentTabComponent='ReceivedMessages'"
          :class="buttonStyle('ReceivedMessages')"
          class="text-sm lg:text-lg tracking-wide text-left px-3" >
          {{$t('messages.received')}}
        </button>
        <div class="border-r-2 border-grey-academy-800"></div>
        <button
          @click="currentTabComponent='SentMessages'" :class="buttonStyle('SentMessages')"
          class="text-sm lg:text-lg tracking-wide text-left px-3">
          {{$t('messages.sent')}}
        </button>
      </div>
      <!--<button class="w-10 h-10 rounded-full"
        :class="isTeacher ? 'bg-beige-academy-500' : 'bg-orange-academy-300'"
        @click="newMessage()">
        <span class="font-extrablack font-sans-serif text-2xl text-white">
          +
        </span>
      </button>-->
    </div>

    <keep-alive>
      <component :is="currentTabComponent" />
    </keep-alive>
    <modal resizable name="messageFormModal" />
    <v-dialog name="inviato" />
  </div>
</template>

<script>
import ReceivedMessages from '@/components/ReceivedMessages.vue';
import SentMessages from '@/components/SentMessages.vue';
import MessageForm from '@/components/modals/MessageForm.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currentTabComponent: 'ReceivedMessages',
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },

  components: {
    ReceivedMessages,
    SentMessages,
  },

  methods: {
    buttonStyle(value) {
      if (value === this.currentTabComponent) return 'text-black font-extrabold border-b-2 border-gray-800';
      return 'hover:text-black transform hover:scale-105 delay-100';
    },

    newMessage() {
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: '' },
        { adaptive: true, draggable: true },
      );
    },
  },
};
</script>
